<template>
  <v-app class="atendimento-hibrido-app">
    <v-app-bar v-if="urlLogoHibrido" color="primary" dark flat dense app>
      <v-img :src="urlLogoHibrido" height="36" width="110" max-height="36" max-width="110" contain class="mx-2"></v-img>
    </v-app-bar>
    <v-main>
      <v-fade-transition>
        <router-view></router-view>
      </v-fade-transition>
    </v-main>
  </v-app>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('app', ['urlLogoHibrido', 'colorThemeHibrido'])
  },
  watch: {
    colorThemeHibrido(novaCor) {
      this.aplicarTema(novaCor)
    }
  },
  methods: {
    aplicarTema(cor) {
      this.$vuetify.theme.themes.light.primary = cor
    }
  },
  created() {
    this.aplicarTema(this.colorThemeHibrido)
  }
}
</script>
<style>
.atendimento-hibrido-app .v-main__wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.atendimento-hibrido-app .v-main__wrap > * {
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>
